import { render, staticRenderFns } from "./FullBoardTitle.vue?vue&type=template&id=1c700fb3&scoped=true&"
import script from "./FullBoardTitle.vue?vue&type=script&lang=js&"
export * from "./FullBoardTitle.vue?vue&type=script&lang=js&"
import style0 from "./FullBoardTitle.vue?vue&type=style&index=0&id=1c700fb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c700fb3",
  null
  
)

export default component.exports